export default __webpack_public_path__ + "static/media/line-items.f445c679.svg";